import {KeasyBootstrap} from './keasy-bootstrap';

declare let window: KeasyBootstrap;

window.copyToClipboard = (text: string): boolean => {
    const input = document.createElement('textarea');
    input.innerHTML = text;

    document.body.appendChild(input);
    input.select();

    const result = document.execCommand('copy');
    document.body.removeChild(input);

    return result;
}

function attachEventListeners(event: Event): void {
    const actions = document.querySelectorAll('[clipboard-value]');

    if (!actions) {
        return;
    }

    actions.forEach((action: Element) => {
        const element = action as HTMLElement;
        const value = action.getAttribute('clipboard-value');
        const event = action.getAttribute('clipboard-event') || 'click';
        const feedbackClass = action.getAttribute('clipboard-feedback-class');
        const feedbackDuration: number = Number.parseInt('' + action.getAttribute('clipboard-feedback-duration')) || 300;

        if (!value) {
            return;
        }

        action.addEventListener(event, () => {
            const success = window.copyToClipboard(value);

            if (!feedbackClass || !success) {
                return;
            }

            element.classList.add(feedbackClass);

            setTimeout(() => {
                element.classList.remove(feedbackClass);
            }, feedbackDuration);
        });
    })
}

window.addEventListener('DOMContentLoaded', (event) => {
    attachEventListeners(event);
}, {once : true});
